module.exports = "/static-assets/_next/static/images/buzzy-award-74b64ae7bc29c436cb20e9b2370f0641.png";